import React from 'react';
import { TableRow, TableCell } from '../../ui/table';
import { Badge } from '../../ui/badge';
import { cn } from '../../../lib/utils';
import { formatCents, formatUSD, formatLevel, formatTimestamp } from '../anniversary/format';
import { StatusBadge, ModerationEditor, PlayerCell, RowActions } from '../anniversary/ModerationEditor';
import { christmasLockReasonText } from './format';

export const COLUMN_COUNT = 11;

export default function ChristmasBonusRow({ row, editing, busy, onEdit, onClose, onModerate }) {
  const overridden = row.override_amount_usd_cents !== null && row.override_amount_usd_cents !== undefined;
  const isVip = row.bonus_type === 'vip';

  return (
    <>
      <TableRow className={cn(!row.editable && 'opacity-70')}>
        <TableCell>
          <PlayerCell row={row} />
        </TableCell>
        <TableCell className="text-ink-dim">{formatLevel(row.level_id)}</TableCell>
        <TableCell>
          <Badge variant={isVip ? 'warning' : 'secondary'}>{isVip ? 'VIP' : (row.bonus_type || '—')}</Badge>
        </TableCell>
        <TableCell className="whitespace-nowrap text-ink">{row.next_christmas || '—'}</TableCell>
        <TableCell className={cn('text-right font-bold', row.ngr_usd_1y < 0 ? 'text-negative' : 'text-ink')}>
          {formatUSD(row.ngr_usd_1y)}
        </TableCell>
        <TableCell className={cn('text-right', overridden ? 'text-ink-mute line-through' : 'font-bold text-ink')}>
          {formatCents(row.proposed_bonus_amount_usd_cents)}
        </TableCell>
        <TableCell className="text-right font-bold text-ink">{overridden ? formatCents(row.override_amount_usd_cents) : ''}</TableCell>
        <TableCell><StatusBadge row={row} fallbackDay={row.next_christmas} /></TableCell>
        <TableCell className="text-xs font-medium text-ink-dim">
          {row.moderated_by && <div>{row.moderated_by}</div>}
          {row.moderated_at && <div className="text-ink-mute">{formatTimestamp(row.moderated_at)}</div>}
        </TableCell>
        <TableCell className="max-w-[220px] truncate text-xs font-medium text-ink-dim" title={row.moderation_note || ''}>
          {row.moderation_note}
        </TableCell>
        <TableCell className="text-right">
          <RowActions row={row} editing={editing} busy={busy} onEdit={onEdit} onClose={onClose} onModerate={onModerate}
            lockText={christmasLockReasonText(row)} />
        </TableCell>
      </TableRow>
      {editing && row.editable && (
        <ModerationEditor row={row} colSpan={COLUMN_COUNT} busy={busy} onModerate={onModerate} onClose={onClose} />
      )}
    </>
  );
}
